export default __webpack_public_path__ + "static/media/ic_people.c0c04363.svg";